var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrecipitation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8H9.5V9H8.5V8ZM9.5 9H10.5V10H9.5V9ZM10.5 10H11.5V11H10.5V10ZM10.5 8H11.5V9H10.5V8ZM8.5 10H9.5V11H8.5V10ZM10.5 6C9.98464 6.01373 9.48484 5.82272 9.11 5.46878C8.73516 5.11483 8.51582 4.6268 8.5 4.1115C8.50932 3.74359 8.62251 3.38582 8.8265 3.0795L10.085 1.207C10.1334 1.14262 10.196 1.09037 10.268 1.05438C10.3401 1.0184 10.4195 0.999666 10.5 0.999666C10.5805 0.999666 10.6599 1.0184 10.732 1.05438C10.804 1.09037 10.8666 1.14262 10.915 1.207L12.1575 3.055C12.3699 3.3674 12.4887 3.73392 12.5 4.1115C12.4842 4.6268 12.2648 5.11483 11.89 5.46878C11.5152 5.82272 11.0154 6.01373 10.5 6ZM10.5 2.3815L9.672 3.613C9.56853 3.75948 9.50887 3.93238 9.5 4.1115C9.51584 4.36153 9.62982 4.59519 9.81711 4.76159C10.0044 4.928 10.2498 5.01369 10.5 5C10.7502 5.01369 10.9956 4.928 11.1829 4.76159C11.3702 4.59519 11.4842 4.36153 11.5 4.1115C11.4888 3.92267 11.4237 3.741 11.3125 3.588L10.5 2.3815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2C14.2349 2.00026 13.9807 2.10571 13.7932 2.29319C13.6057 2.48066 13.5003 2.73486 13.5 3V13H3.5V5H4.5V9L5 10L5.5 9V5H6.5V7L7 8L7.5 7V4H3.5V3C3.49974 2.73486 3.39429 2.48066 3.20681 2.29319C3.01934 2.10571 2.76514 2.00026 2.5 2H1.5V3H2.5V13C2.50026 13.2651 2.60571 13.5193 2.79319 13.7068C2.98066 13.8943 3.23486 13.9997 3.5 14H13.5C13.7651 13.9997 14.0193 13.8943 14.2068 13.7068C14.3943 13.5193 14.4997 13.2651 14.5 13V3H15.5V2H14.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecipitation);
export default __webpack_public_path__ + "static/media/precipitation.b1fdfa2b75b386c78c45058cf43535a4.svg";
export { ForwardRef as ReactComponent };